<template>
  <Avatar v-bind="attibutes" :class="rootClass" />
</template>

<script>
import Avatar from '@/components/common/Avatar/AvatarLink.vue';
export default {
  name: 'WarRoomAvatar',
  components: {
    Avatar,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
  },
  computed: {
    initials() {
      return (this.$attrs.title || this.name).substr(0, 2);
    },
    rootClass() {
      return {
        'war-room-avatar': true,
        'war-room-avatar--w-image': this.$attrs.src,
      };
    },
    attibutes() {
      return { ...this.$attrs, title: this.initials };
    },
  },
};
</script>

<style scoped lang="scss">
.war-room-avatar {
  ::v-deep .avatar {
    background: var(--theme-color-border);
  }

  &--w-image {
    ::v-deep .avatar {
      background: none;
    }
  }
}
</style>
